import { render, staticRenderFns } from "./arrow-switch.vue?vue&type=template&id=126359b6&"
import script from "./arrow-switch.vue?vue&type=script&lang=js&"
export * from "./arrow-switch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports